import { type SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';

import { type AgentMentionConversationContext } from '../types';

type AgentMentionSubmittedAnalyticsPayload = AgentMentionConversationContext & {
	agentId: string;
	selectedAgentCount: number;
	sendAnalyticsEvent: SendAnalyticsEvent;
};

export const sendAgentMentionSubmittedAnalyticsEvent = ({
	agentId,
	selectedAgentCount,
	conversationAgentId,
	sendAnalyticsEvent,
}: AgentMentionSubmittedAnalyticsPayload): void => {
	sendAnalyticsEvent({
		action: 'submitted',
		actionSubject: 'mentionAgent',
		eventType: 'track',
		attributes: {
			agentId,
			source: 'chatInputSubmit',
			selectedAgentCount,
			...(conversationAgentId ? { conversationAgentId } : {}),
		},
	});
};
